import { render, staticRenderFns } from "./catalogo.vue?vue&type=template&id=72135182&scoped=true&"
import script from "./catalogo.vue?vue&type=script&lang=js&"
export * from "./catalogo.vue?vue&type=script&lang=js&"
import style0 from "./catalogo.vue?vue&type=style&index=0&id=72135182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72135182",
  null
  
)

export default component.exports